import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import KambiClient from './kambi-client';
import KambiWidgets from './kambi-widgets';


class Kambi extends React.Component {

  render() {
    const { kambiConfigData } = this.props;
    return (
      <Fragment>
        <KambiClient kambiConfigData={kambiConfigData}/>
        <KambiWidgets/>
      </Fragment>
    );
  }
}

Kambi.propTypes = {
  kambiConfigData: PropTypes.object,
};

export default Kambi;
